<template>
  <div class="w-full space-y-4">
    <!-- Header Section -->
    <div v-if="List.length > 0 || addState" class="flex items-center justify-between">
      <h4 class="text-lg font-semibold text-gray-900 dark:text-white flex items-center">
        <i class="fas fa-map-marker-alt text-red-600 mr-2"></i>
        Ara Noktalar
        <span v-if="List.length" class="ml-2 px-2 py-1 bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300 text-xs rounded-full">
          {{ List.length }}
        </span>
      </h4>
    </div>

    <!-- Add New Waypoint Form -->
    <div v-if="addState && !isDisabled" class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-4 space-y-4">
      <div class="flex items-center justify-between mb-3">
        <h5 class="text-sm font-medium text-gray-700 dark:text-gray-300">Yeni Ara Nokta Ekle</h5>
        <span class="px-2 py-1 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 text-xs rounded-full">
          {{ no }}. Durak
        </span>
      </div>

      <!-- Location Input -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Konum</label>
        <gmapInputVue
          @change="(val) => (position = val)"
          :defaultAdress="position.adress"
          title=""
          :hideMap="true"
          :hideContainer="true"
          class="w-full"
        />
      </div>

      <!-- Details Grid -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
        <!-- Amount -->
        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Miktar (Ton)</label>
          <diffInput
            step="1"
            :min="1"
            type="numberLength"
            :valCount="25"
            title=""
            v-model="amount"
            :hideContainer="true"
            placeholder="0"
          />
        </div>

        <!-- Product -->
        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Ürün</label>
          <productInput
            v-model="productId"
            :toggleSelectAll="true"
            placeholder="Ürün seçiniz"
            :hideContainer="true"
            @changeName="(r) => (productType = r)"
          />
        </div>

        <!-- Date -->
        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Tarih</label>
          <diffInput
            title=""
            type="datetime-local"
            v-model="date"
            :hideContainer="true"
            :min="minDate"
            :max="maxDate"
          />
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex items-center justify-end space-x-2 pt-2 border-t border-gray-200 dark:border-gray-700">
        <button
          type="button"
          @click="addState = false"
          class="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg transition-colors"
        >
          <i class="fas fa-times mr-1"></i>
          İptal
        </button>
        <button
          type="button"
          @click="save()"
          :disabled="isDisabled"
          class="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 disabled:bg-gray-400 rounded-lg transition-colors"
        >
          <i class="fas fa-plus mr-1"></i>
          Ekle
        </button>
      </div>
    </div>

    <!-- Existing Waypoints List -->
    <div v-if="List.length > 0" class="space-y-3">
      <div
        v-for="(item, index) in List"
        :key="index"
        class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-4 hover:shadow-md transition-shadow"
      >
        <div class="flex items-start justify-between">
          <div class="flex-1 space-y-2">
            <!-- Header with number and location -->
            <div class="flex items-center space-x-3">
              <span class="flex items-center justify-center w-8 h-8 bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400 rounded-full text-sm font-semibold">
                {{ item.no }}
              </span>
              <div class="flex-1">
                <p class="text-sm font-medium text-gray-900 dark:text-white">{{ item.position.adress }}</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">{{ item.date | dateFormatter }}</p>
              </div>
            </div>
            
            <!-- Details -->
            <div class="grid grid-cols-2 gap-4 ml-11">
              <div class="flex items-center space-x-2">
                <i class="fas fa-weight-hanging text-gray-400 text-xs"></i>
                <span class="text-sm text-gray-600 dark:text-gray-400">{{ item.amount }} Ton</span>
              </div>
              <div class="flex items-center space-x-2">
                <i class="fas fa-cube text-gray-400 text-xs"></i>
                <span class="text-sm text-gray-600 dark:text-gray-400">{{ item.productType }}</span>
              </div>
            </div>
          </div>
          
          <!-- Delete Button -->
          <button
            :disabled="isDisabled"
            type="button"
            @click="removeItem(index)"
            class="ml-4 p-2 text-red-500 hover:bg-red-50 dark:hover:bg-red-900/30 rounded-lg transition-colors disabled:opacity-50"
            title="Ara noktayı sil"
          >
            <i class="fas fa-trash text-sm"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Add Button -->
    <button
      v-if="!addState && !isEdit && canShowWaypoints"
      type="button"
      @click="addState = true"
      class="w-full p-4 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg text-gray-500 dark:text-gray-400 hover:border-red-400 hover:text-red-600 dark:hover:text-red-400 transition-colors flex items-center justify-center space-x-2"
    >
      <i class="fas fa-plus"></i>
      <span>Ara Nokta Ekle</span>
    </button>
  </div>
</template>

<script>
// NPM
import moment from "moment";

// Global Components
import gmapInputVue from "@/components/general/gmapInput.vue";
import diffInput from "@/components/general/diffInput.vue";
import productInput from "@/components/devItem/productInput.vue";

// Utils
import { calculateDistancePriority } from "@/utils/recomendation";
export default {
  props: ["value", "maxTonnage", "maxDate", "minDate", "isDisabled","isEdit","canShowWaypoints"],
  model: {
    prop: "value",
    event: "change",
  },
  components: {
    diffInput,
    gmapInputVue,
    productInput,
  },
  data() {
    return {
      List: [],
      productId: null,
      productType: "",
      tonnage: 0,
      addState: false,
      no: 1,
      name: 0,
      position: { lat: 0, lng: 0, adress: "" },
      amount: 0,
      date: "",
    };
  },
  methods: {
    save() {
      try {
        if (this.no <= 0) {
          this.$swal.fire({
            icon: 'warning',
            title: 'Geçersiz Sıralama',
            text: 'Ara noktalarda sıralama 1\'den başlamalıdır!',
            confirmButtonText: 'Tamam'
          });
          return;
        }

        if (this.amount <= 0) {
          this.$swal.fire({
            icon: 'warning',
            title: 'Geçersiz Miktar',
            text: 'Ara noktalarda miktar 0\'dan büyük olmalıdır!',
            confirmButtonText: 'Tamam'
          });
          return;
        }

        if (!this.date) {
          this.$swal.fire({
            icon: 'warning',
            title: 'Tarih Gerekli',
            text: 'Tarih alanı boş bırakılamaz!',
            confirmButtonText: 'Tamam'
          });
          return;
        }

        if (!this.position.adress) {
          this.$swal.fire({
            icon: 'warning',
            title: 'Konum Gerekli',
            text: 'Ara noktanın konumunu seçmelisiniz!',
            confirmButtonText: 'Tamam'
          });
          return;
        }

        if (!this.productType) {
          this.$swal.fire({
            icon: 'warning',
            title: 'Ürün Gerekli',
            text: 'Ürün seçmeniz gerekmektedir!',
            confirmButtonText: 'Tamam'
          });
          return;
        }

        if (moment(this.date).diff(this.maxDate, "minutes") > 1) {
          this.$swal.fire({
            icon: 'error',
            title: 'Geçersiz Tarih',
            text: 'Ara nokta için planlanan süre operasyonunun tamamlanma süresinden büyük olamaz!',
            confirmButtonText: 'Tamam'
          });
          return;
        }

        if (moment(this.date).diff(this.minDate, "minutes") < 1) {
          this.$swal.fire({
            icon: 'error',
            title: 'Geçersiz Tarih',
            text: 'Ara nokta için planlanan süre operasyonun başlangıç süresinden küçük olamaz!',
            confirmButtonText: 'Tamam'
          });
          return;
        }

        const waypointsAccAmount =
          this.List.reduce(
            (accumulator, item) => accumulator + Number(item.amount),
            0
          ) + Number(this.amount);

        if (waypointsAccAmount > Number(this.maxTonnage)) {
          this.$swal.fire({
            icon: 'warning',
            title: 'Kapasite Aşıldı',
            text: 'Yapılacak siparişlerin toplam miktarı aracın kapasitesini aşmış olabilir lütfen kontrol ediniz!',
            confirmButtonText: 'Tamam'
          });
          return;
        }

        if (this.List.length > 0) {
          const item = this.List[this.List.length - 1];

          const oldItemDate = new moment(item.date);

          const distance =
            calculateDistancePriority(
              {
                startLat: item.position.lat,
                startLng: item.position.lng,
              },
              {
                latitude: this.position.lat,
                longitude: this.position.lng,
              }
            ) / 1000; // metre to km

          const diff = moment(this.date).diff(oldItemDate, "minutes");

          const targetHour = (distance / 60) * 60;

          if (diff < 0) {
            this.$swal.fire({
              icon: 'error',
              title: 'Geçersiz Sıralama',
              text: 'Daha önceden belirlenmiş teslimat tarihinden önce bir teslimat yapmamız mümkün değildir.',
              confirmButtonText: 'Tamam'
            });
            return;
          } else if (diff < targetHour) {
            this.$swal.fire({
              icon: 'error',
              title: 'Yetersiz Süre',
              text: `Daha önceden belirlenmiş teslimat minimum ${moment(oldItemDate).add(targetHour, "minutes").format("LLL")} önce bir teslimat yapmamız mümkün değildir.`,
              confirmButtonText: 'Tamam'
            });
            return;
          }
        }

        this.tonnage += parseFloat(this.amount);

        this.List.push({
          no: this.no,
          name: this.name,
          position: this.position,
          amount: this.amount,
          date: this.date,
          productType: this.productType,
        });

        this.no = this.List.length + 1;
        this.name = "";
        this.position = { adress: "" };
        this.amount = "";
        this.date = "";
        this.addState = false;
        
        this.$swal.fire({
          icon: 'success',
          title: 'Başarılı',
          text: 'Ara nokta başarıyla eklendi!',
          timer: 1500,
          showConfirmButton: false
        });
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: 'Hata',
          text: 'Ara nokta eklenemedi!',
          confirmButtonText: 'Tamam'
        });
      }
    },
    removeItem(val) {
      try {
        this.$swal.fire({
          title: 'Ara Noktayı Sil',
          text: 'Bu ara noktayı silmek istediğinize emin misiniz?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#dc2626',
          cancelButtonColor: '#6b7280',
          confirmButtonText: 'Evet, Sil',
          cancelButtonText: 'İptal'
        }).then((result) => {
          if (result.isConfirmed) {
            this.tonnage -= parseFloat(this.List[val].amount);
            this.List.splice(val, 1);

            setTimeout(() => {
              this.List = this.List.map((item, index) => {
                return {
                  ...item,
                  no: index + 1,
                };
              });

              this.no = this.List.length + 1;
            }, 50);

            this.$swal.fire({
              icon: 'success',
              title: 'Silindi',
              text: 'Ara nokta başarıyla silindi!',
              timer: 1500,
              showConfirmButton: false
            });
          }
        });
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: 'Hata',
          text: 'Ara nokta silinemedi!',
          confirmButtonText: 'Tamam'
        });
      }
    },
  },
  created() {
    this.List = [];
  },
  filters: {
    dateFormatter(val) {
      return moment(val).format("LLLL");
    },
  },
  watch: {
    value(val) {
      this.List = val;
    },
    List(val) {
      this.$emit("update:waypoints", val);
    },
  },
};
</script>
